import { createSelector } from '@ngrx/store';

import { Stage, StageCategory } from '@recruitee/http-types';
import { createEntityCollectionStore } from '@recruitee/ngrx';

const { actions, reducer, namespace, selectors } = createEntityCollectionStore<Stage>()(
  'offer-stages',
  {
    customActions: adapter => ({
      references: (state, payload: { data: Stage[] }) =>
        adapter.updateOrCreateMany(state, payload.data),
    }),
  },
);

const StageActions = <Pick<typeof actions, 'references'>>actions;

const dropdownSelectableStages = createSelector(selectors.allEntities, stages =>
  stages.filter(stage => !stage.locked || (stage.locked && stage.category === StageCategory.Apply)),
);

const StageSelectors = {
  ...selectors,
  dropdownSelectableStages,
};

export { StageActions, StageSelectors, reducer as StageReducer, namespace as StageNamespace };
